export type StorageItem = string | null

export function hasStorageItem(key: string): boolean {
  return window?.localStorage.getItem(key) !== null
}

export function getStorageItem(key: string): StorageItem | undefined {
  return window?.localStorage.getItem(key)
}

export function setStorageItem(key: string, value: string): void {
  return window?.localStorage.setItem(key, value)
}

export function remStorageItem(key: string): void {
  return window?.localStorage.removeItem(key)
}
